if($('header').length){

    $('.responsive-tools').append('<div class="infoPopup"></div>', $('.top-navigation-tools .languagesMenu').clone())
    $('.responsive-tools').append($('header#header .header-top .navigation-buttons a[data-target="cart"]'))
    $('.header-top').append($('.responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">E-mail<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">Heslo<span>*</span></label>')
    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');    
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    })
    $('<span class="close"></span>').appendTo('.search');
    $('header#header').before($('.header-top .search').clone().addClass('customSearch'))
    $(document).on("click", ".search .close", function(){
        $('body').removeClass('user-action-visible search-window-visible')
        $('header#header .search input.search-input').val('')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.search').length || clickedElement.is('a[data-target="search"]'))) {
            $('body').removeClass('search-window-visible user-action-visible');
            $('header#header .search input.search-input').val('')
        }
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });
    $('nav#navigation .menu-image img').each(function(){
        if($(this).attr('data-src')){
            $(this).attr('data-src', $(this).attr('data-src').replace('thumb', 'orig'))
            $(this).attr('src', $(this).attr('data-src'))
        }
       
    })
    $('html[lang="sk"] .languagesMenu__box[data-target="language"] .languagesMenu__header.languagesMenu__header--actual').prepend('<svg class="shp-flag shp-flag-SK"><use xlink:href="#shp-flag-SK"></use></svg>')
    $('html[lang="cs"] .languagesMenu__box[data-target="language"] .languagesMenu__header.languagesMenu__header--actual').prepend('<svg class="shp-flag shp-flag-CZ"><use xlink:href="#shp-flag-CZ"></use></svg>')

    $('html').on('click', '.infoPopup', function(e){
        e.preventDefault();
        $.colorbox({
            html: $('footer#footer .infoPopup').closest('span').html(),
            width: 600,
            maxWidth: "90%",
            height: 265,
            maxHeight: "90%",
           // className: "infoPopup",
            onComplete: function() {
                
            },
        });
    })
}